module.exports = __webpack_public_path__ + "static/media/success-en.266687c1.png";